import Rest from "@/services/api_config/RestApi";

export default {
  getPages(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    return Rest().get("tripko/com/page?" + data.substring(1));
  },
  getPage(id) {
    return Rest().get("tripko/com/page/" + id);
  },
  addPage(data) {
    return Rest().put("tripko/com/add-page", data);
  },
  editPage(id, data) {
    return Rest().patch("tripko/com/page/" + id, data);
  },
  deletePage(id) {
    return Rest().delete("tripko/com/page/" + id);
  },
  getModules(params) {
    var data = ``;
    if (
      params.page_id !== null &&
      params.page_id !== undefined &&
      params.page_id !== ""
    ) {
      data += `&page_id=${params.page_id}`;
    }
    return Rest().get("tripko/com/module?" + data.substring(1));
  },
  getModule(id) {
    return Rest().get("tripko/com/module/" + id);
  },
  editModule(id, data) {
    return Rest().patch("tripko/com/module/" + id, data);
  },
  addModule(data) {
    return Rest().put("tripko/com/add-module", data);
  },
  deleteModule(id) {
    return Rest().delete("tripko/com/module/" + id);
  },
  getRoles(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("tripko/com/role?" + data.substring(1));
  },
  getRole(id) {
    return Rest().get("tripko/com/role/" + id);
  },
  editRole(id, data) {
    return Rest().patch("tripko/com/role/" + id, data);
  },
  deleteRole(id) {
    return Rest().delete("tripko/com/role/" + id);
  },
  addRole(data) {
    return Rest().put("tripko/com/add-role", data);
  },
  getEmployees(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("tripko/com/employee?" + data.substring(1));
  },
  getEmployee(id) {
    return Rest().get("tripko/com/employee/" + id);
  },
  addEmployee(data) {
    return Rest().put("tripko/com/add-employee", data);
  },
  editEmployee(id, data) {
    return Rest().patch("tripko/com/employee/" + id, data);
  },
  deleteEmployee(id) {
    return Rest().delete("tripko/com/employee/" + id);
  },
  uploadEmployees(data) {
    return Rest().put("tripko/com/upload-employee", data);
  },
  getUnassignedEmployees(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("tripko/com/unassigned-employee?" + data.substring(1));
  },
  assignEmployees(params) {
    return Rest().post("tripko/com/assign-employee/", params);
  },
  getUser(id) {
    return Rest().get("jti/user/" + id);
  },
  getCompanies(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("tripko/com/sub-company?" + data.substring(1));
  },
  getCompany(id) {
    return Rest().get("tripko/com/sub-company/" + id);
  },
  getManageCompany(id) {
    return Rest().get("tripko/com/sub-company/manage/" + id);
  },
  getCompanySettings(id) {
    return Rest().get("tripko/com/sub-company/settings/" + id);
  },
  editCompanySettings(id, body) {
    return Rest().patch("tripko/com/sub-company/settings/" + id, body);
  },
  getSubCompanies(params) {
    var data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("jti/sub-company?" + data.substring(1));
  },
  getAccessCards(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("tripko/com/access-card?" + data.substring(1));
  },
  getAccessCard(id) {
    return Rest().get("tripko/com/access-card/" + id);
  },
  addAccessCard(data) {
    return Rest().put("tripko/com/access-card", data);
  },
  deleteAccessCard(id) {
    return Rest().delete("tripko/com/access-card/" + id);
  },
  getUnassignedAccessCards(params) {
    var data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get(
      "tripko/com/unassigned-access-card?" + data.substring(1)
    );
  },
  uploadAccessCards(data) {
    return Rest().put("tripko/com/upload-access-card", data);
  },
  getSoftwareSerials(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.is_assigned !== null &&
      params.is_assigned !== undefined &&
      params.is_assigned !== ""
    ) {
      data += `&is_assigned=${params.is_assigned}`;
    }
    return Rest().get("tripko/com/software-serial?" + data.substring(1));
  },
  getSoftwareSerial(id) {
    return Rest().get("tripko/com/software-serial/" + id);
  },
  addSoftwareSerial(data) {
    return Rest().put("tripko/com/add-software-serial", data);
  },
  editSoftwareSerial(id, data) {
    return Rest().patch("tripko/com/software-serial/" + id, data);
  },
  deleteSoftwareSerial(id) {
    return Rest().delete("tripko/com/software-serial/" + id);
  },
  getDevices(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("tripko/com/device?" + data.substring(1));
  },
  getDevice(id) {
    return Rest().get("tripko/com/device/" + id);
  },
  addDevice(data) {
    return Rest().put("tripko/com/add-device", data);
  },
  editDevice(id, data) {
    return Rest().patch("tripko/com/device/" + id, data);
  },
  deleteDevice(id) {
    return Rest().delete("tripko/com/device/" + id);
  },
  getUnassignedDevices(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("tripko/com/unassigned-device?" + data.substring(1));
  },
  assignDevices(data) {
    return Rest().post("tripko/com/assign-device/", data);
  },
  getTerminals(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("tripko/com/terminal?" + data.substring(1));
  },
  getTerminal(id) {
    return Rest().get("tripko/com/terminal/" + id);
  },
  addTerminal(data) {
    return Rest().put("tripko/com/terminal", data);
  },
  editTerminal(id, data) {
    return Rest().patch("tripko/com/terminal/" + id, data);
  },
  deleteTerminal(id) {
    return Rest().delete("tripko/com/terminal/" + id);
  },
};
